import { render, staticRenderFns } from "./view-doc.vue?vue&type=template&id=cafc0db2"
import script from "./view-doc.vue?vue&type=script&lang=js"
export * from "./view-doc.vue?vue&type=script&lang=js"
import style0 from "./view-doc.vue?vue&type=style&index=0&id=cafc0db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports